import { countrystatecityregion, selectOption } from "../../../commonClass/CommonInterfaceTypes";

export class SupplierProfileModal {
    SupplierId: number;
    LocationId: number;
    SupplierTypeId: number[];
    HOId: number;
    SupplierName: string;
    OfficeNo: string;
    HouseNo: string;
    BuildingName: string;
    BuildingNo: string;
    Street: string;
    Locality: string;
    Landmark: string;
    Pincode: string;
    Website: string;
    AboutSupplier: string;

    IncorporationNo: string;
    IncorporationCertiPath: string;
    PANNo: string;
    panDocPath: string;
    GSTNNo: string;
    gstnDocPath: string;
    datacollection: AffiliationsDataCollection[];

    ContractFormDocPath: string;
    AgreementLetterDocPath: string;
    IsOnline: boolean;
    IsOffline: boolean;

    IsActive: boolean;
    UserId: number;

    constructor() {
        this.SupplierId = 0;
        this.LocationId = 0;
        this.SupplierTypeId = [];
        this.HOId = 0;
        this.SupplierName = "";
        this.OfficeNo = "";
        this.HouseNo = "";
        this.BuildingName = "";
        this.BuildingNo = "";
        this.Street = "";
        this.Locality = "";
        this.Landmark = "";
        this.Pincode = "";
        this.Website = "";
        this.AboutSupplier = "";

        this.IncorporationNo = "";
        this.IncorporationCertiPath = "";
        this.PANNo = "";
        this.panDocPath = "";
        this.GSTNNo = "";
        this.gstnDocPath = "";
        this.datacollection = [];

        this.ContractFormDocPath = "";
        this.AgreementLetterDocPath = "";
        this.IsOnline = false;
        this.IsOffline = false;

        this.IsActive = false;
        this.UserId = 0;

    }
}
export class AccoutDetailsModal {
    SupplierAccountId: number;
    SupplierId: number;
    AccountNumber: string;
    AccountName: string;
    BankName: string;
    IFSCCode: string;
    BranchName: string;
    BranchCode: string;
    PANNo: string;
    MICRNumber: string;
    TANNo: string;
    MobileNo: string;
    Email: string;
    IsActive: boolean;
    DataCollection: SupplierPolicyDataCollection[];
    UserId: number;

    constructor() {
        this.SupplierAccountId = 0;
        this.SupplierId = 0;
        this.AccountNumber = '';
        this.AccountName = '';
        this.BankName = '';
        this.IFSCCode = '';
        this.BranchName = '';
        this.BranchCode = '';
        this.PANNo = '';
        this.MICRNumber = '';
        this.TANNo = '';
        this.MobileNo = '';
        this.Email = '';
        this.IsActive = false;
        this.DataCollection = [];
        this.UserId = 0;
    }
}


export class ETMAccountManagemnetModal {
    supplierMngtId: number;
    supplierId: number;
    kamName: string;
    kamEmail: string;
    kamMobNo: string;
    amName: string;
    amEmail: string;
    amMobNo: string;
    mName: string;
    mEmail: string;
    mMobileNo: string;
    UserId: number;

    constructor() {
        this.supplierMngtId = 0;
        this.supplierId = 0;
        this.kamName = '';
        this.kamEmail = '';
        this.kamMobNo = '';
        this.amName = '';
        this.amEmail = '';
        this.amMobNo = '';
        this.mName = '';
        this.mEmail = '';
        this.mMobileNo = '';
        this.UserId = 0;
    }
}

export class SupplierPolicyDataCollection {
    SeqNo: number;
    dTravelId: number;
    dTravelValue: string;
    sPaymentId: number;
    sPaymentValue: string;

    constructor() {
        this.SeqNo = 0;
        this.dTravelId = 0;
        this.dTravelValue = '';
        this.sPaymentId = 0;
        this.sPaymentValue = '';
    }
}

export interface OtherlocationIds {
    ContinentId: number,
    CountryId: number,
    RegionId: number,
    StateId: number,
}
export interface AffiliationsDataCollection {
    seqNo: number;
    docName: string;
    fileName: string;
    filePath: string;
}

export interface SupplierProps {
    locationsData?: countrystatecityregion;
    dropdownData?: SupplierDropdownData;
    SupplierId: number;
    disable: boolean;
    editdisable: boolean;
    cleardisable: boolean;
    type: string;
    retrieveData: any;
    UserId: number;
    SupplierName?: string;
    supplierList?: any[];
}

export interface SupplierData {
    SupplierProfile: any;
    AccountDetails: any;
    AccountManagement: any;
}
export class SupplierDataModal {
    SupplierProfile: any;
    AccountDetails: any;
    AccountManagement: any;

    constructor() {
        this.SupplierProfile = null;
        this.AccountDetails = null;
        this.AccountManagement = null;
    }
}

export interface SupplierDropdownData {
    SupplierType: selectOption[],
    StateofIncorporation: selectOption[],
    DTravel: selectOption[],
    SupplierPaymentValue: selectOption[],
}

